import React from 'react';

export default function Banner({ name }) {
    return (
        <div className='d-flex flex-center vh-20 app-blue w-100'>
            <h2 className='text-white text-uppercase'>{name}</h2>
        </div>
    )
}